<template>
  <el-dialog
    :title="$t('deleteService.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose">
    <div class="text-center">
      <p>{{ $t('deleteService.confirmDeleteService') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteService.cancel') }}</el-button>
      <el-button type="primary" @click="deleteService">{{ $t('deleteService.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteService } from '@/api/dev/serviceManage/serviceManageApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteService',
  data() {
    return {
      dialogVisible: false,
      deleteServiceInfo: {}
    }
  },
  methods: {
    open(service) {
      this.dialogVisible = true
      this.deleteServiceInfo = { ...service }
    },
    handleClose() {
      this.deleteServiceInfo = {}
    },
    async deleteService() {
      try {
        this.deleteServiceInfo.shopId = getShopId()
        await deleteService(this.deleteServiceInfo)
        this.$message.success(this.$t('deleteService.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error('删除服务失败:', error)
        this.$message.error(this.$t('deleteService.deleteFailed'))
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>